import { render } from "./DisciplineSuggestions.vue?vue&type=template&id=6fac4aea&scoped=true&ts=true"
import script from "./DisciplineSuggestions.ts?vue&type=script&lang=ts&external"
export * from "./DisciplineSuggestions.ts?vue&type=script&lang=ts&external"

import "./DisciplineSuggestions.scss?vue&type=style&index=0&id=6fac4aea&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fac4aea"]])

export default __exports__